import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Cómo recibo el Megapack después de comprar?',
  answer: 'Inmediatamente después de confirmar tu pago por Mercado Pago, recibirás un email con el acceso directo a todos los tomos y bonos en formato PDF. Podés descargarlos en cualquier dispositivo y empezar a trabajar en los próximos 5 minutos.'
}, {
  question: '¿Sirve si nunca fabriqué un mueble en mi vida?',
  answer: 'Sí, el Megapack está diseñado específicamente para principiantes absolutos. Empezás desde cero con el Tomo 1 que te enseña los fundamentos, y avanzás paso a paso con planos detallados, medidas exactas y fotografías de cada etapa. Los primeros 3 proyectos están pensados para que los completes en un fin de semana sin experiencia previa.'
}, {
  question: '¿Necesito un taller equipado o me alcanza con lo que tengo en casa?',
  answer: 'Te alcanza con un balcón, lavadero o cochera. El Tomo 2 te muestra exactamente qué herramientas básicas necesitás (muchas las tenés en casa) y cómo armar tu espacio de trabajo mínimo. No necesitás maquinaria profesional ni inversión grande en equipamiento.'
}, {
  question: '¿Los 5 bonos están incluidos en las dos ofertas?',
  answer: 'Sí, tanto el Megapack Esencial como el PRO incluyen los 5 bonos completos sin costo adicional: Guía de Proveedores Argentina, Planilla de Costos, Planos para Imprimir, Guía de Fotografía y Guía de Primeras Ventas. La diferencia está en que el PRO suma además el Tomo 7 (Marca Personal) y Tomo 8 (Mapa de Ruta 90 días).'
}, {
  question: '¿Sirve si vivo en el interior del país y no tengo corralones cerca?',
  answer: 'Sí, el Bono 1 incluye la Guía de Proveedores por región (CABA, GBA, Córdoba, Rosario y más provincias). Además, te mostramos alternativas de compra online y cómo adaptar materiales disponibles en tu zona. El sistema está pensado para funcionar en toda Argentina.'
}, {
  question: '¿Qué pasa si no sé nada de carpintería ni de diseño?',
  answer: 'No hay problema. El Megapack arranca desde los fundamentos del estilo Japandi y te lleva de la mano con instrucciones paso a paso, fotografías de cada etapa y planos con medidas exactas. No asumimos ningún conocimiento previo. Si sabés usar un destornillador, podés empezar.'
}, {
  question: '¿Qué diferencia tiene con tutoriales gratis en YouTube?',
  answer: 'Los tutoriales de YouTube están en inglés, usan materiales y proveedores de otros países, no tienen planos descargables con medidas exactas, y no te enseñan cómo vender ni calcular precios. El Megapack es un sistema completo adaptado a Argentina: materiales locales, proveedores por región, fórmula de precio, estrategia de ventas y marca personal. Todo en español y listo para usar.'
}, {
  question: '¿Por qué elegir el Megapack PRO y no el Esencial?',
  answer: 'El Esencial te da todo lo necesario para fabricar los 6 muebles con calidad profesional. El PRO suma el Tomo 7 (Kit de Marca Personal) y el Tomo 8 (Mapa de Ruta 90 días), que te dan identidad de marca, posicionamiento y un plan concreto semana a semana para llegar a tus primeros $3000 USD/mes. Si querés convertir esto en negocio real, el PRO te ahorra meses de prueba y error.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí, garantía total de 7 días. Probás el Megapack, seguís los planos, arrancás tu primer proyecto. Si no es lo que esperabas, te devolvemos el 100% sin preguntas. Nuestra tasa de devoluciones es menor al 1% porque el contenido cumple lo que promete.'
}];
export function FAQ() {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  return <section className="py-8 md:py-16 px-4 bg-white" data-id="element-60">
      <div className="max-w-4xl mx-auto" data-id="element-61">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-5xl font-bold text-center mb-2 md:mb-4" data-id="element-62">
          DUDAS COMUNES
        </motion.h2>

        <p className="text-center text-sm md:text-lg mb-6 md:mb-12 text-[#2B2724]/80" data-id="element-63">
          PREGUNTAS FRECUENTES
        </p>

        <div className="space-y-3 md:space-y-4" data-id="element-64">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.03
        }} className="bg-[#F5F0E8] rounded-lg border border-[#2B2724]/10 overflow-hidden" data-id="element-65">
              <button onClick={() => setExpandedIndex(expandedIndex === index ? null : index)} className="w-full p-4 md:p-6 text-left flex items-center justify-between hover:bg-[#EDE6D8] transition-colors" aria-expanded={expandedIndex === index} data-id="element-66">
                <h3 className="font-bold text-sm md:text-base pr-4" data-id="element-67">
                  {faq.question}
                </h3>
                <motion.div animate={{
              rotate: expandedIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="flex-shrink-0" data-id="element-68">
                  <ChevronDown className="w-5 h-5 md:w-6 md:h-6 text-[#C2613A]" data-id="element-69" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-70">
                {expandedIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-71">
                    <div className="px-4 pb-4 md:px-6 md:pb-6 border-t border-[#2B2724]/10 pt-3 md:pt-4" data-id="element-72">
                      <p className="text-xs md:text-sm text-[#2B2724]/80 leading-relaxed" data-id="element-73">
                        {faq.answer}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}